import { render, staticRenderFns } from "./CollectionCreate.vue?vue&type=template&id=52d70858&scoped=true&"
import script from "./CollectionCreate.vue?vue&type=script&lang=js&"
export * from "./CollectionCreate.vue?vue&type=script&lang=js&"
import style0 from "./CollectionCreate.vue?vue&type=style&index=0&id=52d70858&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d70858",
  null
  
)

export default component.exports